export default __webpack_public_path__ + "static/media/app-promo-landscape.21494063.jpeg";